import strapi, { mapStrapiData } from '../lib/strapi';
import qs from 'qs';

export const getContactPageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_image: true
      }
    });

    const response = await strapi.get(`/contact-page?${query}`);
    return mapStrapiData(response);
  } catch (error) {
    console.error('Error fetching Contact Page data:', error);
    return null;
  }
};